<template>
  <div>
    <filter-modal :is-modal-open="isFilterModalOpen" :default-fields="filterFields" @set-filter="setFilter"
      @close-modal="closeFilterModal" />
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-2">
        <v-card elevation="0" height="88vh" class="main-dashboard-115-card body-card">
          <v-card-text>
            <v-row>
              <v-col cols="2" class="covered-position pb-0">
                <span class="current-mission-header-content">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-3" v-bind="attrs" v-on="on" @click="getQCDashboardFunction(filterFields)">
                        mdi-cached mdi-18px
                      </v-icon>
                    </template>
                    <span>به روز رسانی</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openFilterModal">
                        mdi-filter mdi-18px
                      </v-icon>
                    </template>
                    <span>فیلتر</span>
                  </v-tooltip>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-card height="15vh" class="data-card1" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-clock-time-four mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="4" class="mr-3">
                        <h2 class="data-card-title">کاربران آنلاین</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboardQCOnlineUser }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card2" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">ماموریت ها</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboardQCMissionCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card3" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">کد ها فعال</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboardQCActiveCode }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card4" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">کد های 7-10</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2" class="text-left ml-2">
                        <h2 class="data-card-content">
                          {{ dashboardQC107Code }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-text mdi-48px</v-icon>
                    <span class="chart-title-content">نظرسنجی</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboardQCPieSurveynChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboardQCPieSurveyChartOptions" ref="pieSsurvey"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-cog mdi-48px</v-icon>
                    <span class="chart-title-content">وضعیت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboardQCPieRankChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboardQCPieRankChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-phone mdi-48px</v-icon>
                    <span class="chart-title-content">نتیجه تماس ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboardQCPieCallChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboardQCPieCallChartOptions" ref="pieCall"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="28vh" class="detail-115-dashboard-card" elevation="0">
                  <!--<v-row no-gutters>
                      <v-col cols="12">
                        <v-img
                          :src="dashboardIMG2"
                          contain
                          class="second-row-img2"
                        ></v-img>
                      </v-col>
                    </v-row>-->
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="3">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین تماس تا اعزام</span>
                          </v-col>
                          <v-col cols="12" class="mt-n3">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCCallToSend }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-1 mr-3">-</span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین تماس تا رسیدن</span>
                          </v-col>
                          <v-col cols="12" class="mt-n3">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCCallToArrive }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCCallToArriveFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین اعزام تا رسیدن</span>
                          </v-col>
                          <v-col cols="12" class="mt-n3">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCSendToArrive }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCSendToArriveFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین دریافت تا حرکت</span>
                          </v-col>
                          <v-col cols="12" class="mt-n3">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCGetToMove }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCGetToMoveFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-5">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین حرکت تا رسیدن</span>
                          </v-col>
                          <v-col cols="12" class="mt-n2">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCMoveToArrive }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCMoveToArriveFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-5">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین ماندگاری بر بالین</span>
                          </v-col>
                          <v-col cols="12" class="mt-n2">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCStayPatient }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCStayPatientFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-5">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین ماندگاری در بیمارستان</span>
                          </v-col>
                          <v-col cols="12" class="mt-n2">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCStayHospital }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCStayHospitalFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-5">
                        <v-row class="pr-7">
                          <v-col cols="12">
                            <span class="data-card-title2">میانگین تماس تا پایان</span>
                          </v-col>
                          <v-col cols="12" class="mt-n2">
                            <v-row>
                              <v-icon color="#212121">mdi-account mdi-18px</v-icon>
                              <span class="data-card-content2 mt-1 mr-3">
                                {{ dashboardQCCallToFinish }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col cols="12" class="mt-n1">
                            <v-row>
                              <v-icon color="darkColor">mdi-vector-square mdi-18px</v-icon>
                              <span class="data-card-content3 mt-2 mr-3">
                                {{ dashboardQCCallToFinishFence }}
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">ماموریت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboardQCLineMissionChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboardQCLineMissionChartOptions" ref="lineMission"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../components/AlertComponent.vue';
import FilterModal from '@/components/Qc/dashboard/filter.modal.vue';
import DashboardQCHelper from '@/Helpers/QC/DashboardQCHelper.js';
import SharedHelper from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
export default {
  name: 'DashboardQCView',
  title: 'داشبورد کنترل کیفیت',
  components: { AlertComponent, FilterModal },
  mixins: [DashboardQCHelper, SharedHelper, DashboardMixin, snackBar, ShearedMixin],
  created() {
    this.$root.$refs.DashboardQC = this;
  },
  mounted() {
    this.mounteLoding();
  },
  beforeDestroy() { },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.initialFilter();
      this.getQCDashboardFunction(this.filterFields);
    },
  },
};
</script>
<style scoped>
.covered-position {
  /* margin-top: -3.5vh !important; */
  position: relative;
  z-index: 2;
  /* padding-top: 1.5rem; */
}

.current-mission-header-content {
  font-size: 13px;
  color: var(--dark-color) !important;

  padding-right: 20px !important;
  padding-left: 20px !important;
}

.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid #2edf93 !important;
}

.body-card {
  overflow: hidden;
}

.body-card:hover {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}


.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  background: linear-gradient(250deg, var(--one-field-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  background: linear-gradient(250deg, var(--new-call-effect) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

>>>.second-row-img2 {
  position: absolute;
  margin-top: 1.5%;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-title2 {
  color: #212121;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-content2 {
  color: black;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 1.3px;
}

.data-card-content3 {
  color: var(--dark-color);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

>>>.highcharts-reset-zoom text {
  transform: translate(63px, 2px) !important;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>
